import React from "react";
import Skills from "./Skills.mobile";
import ViewMoreContent from "./ViewMoreContent.mobile";
import Translation from "./../Translation/Translation.mobile";

import styles from "./Desc.mobile.module.scss";
import Benefits from "../Benefits/Benefits.mobile";

export default function Desc({ data, countryKey, transData }) {
  const isJp = countryKey === "jp";

  return (
    <div className={styles.descContentWrap}>
      <div className={styles.descContent}>
        <div className={styles.descTitle}>
          <h3>{data.title}</h3>
          <Translation aiTranslate={data.aiTranslate} />
        </div>
        <Benefits data={data.benefits_info} />
        <ViewMoreContent transData={transData} data={data} />
        {/* <Skills data={transData.isOriginal ? data.skills : data.translationSkills} /> */}
      </div>
    </div>
  );
}
